"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CancelLinkButton = exports.LinkButton = exports.SubmitButton = exports.ButtonWithProgress = exports.Button = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _base = require("../../base");

var _theme = require("../../styles/theme");

var _icons = require("../../ui_elements/icons");

var buttonVariants = _interopRequireWildcard(require("./button-variants"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Button = (
/*#__PURE__*/
0, _styledBase.default)('button', {
  target: "eimavvp0",
  label: "Button"
})("align-items:center;appearance:none;background:none;border-radius:3px;border:1px solid transparent;box-sizing:border-box;cursor:pointer;display:inline-flex;font-family:", _theme.fonts.sans.family, ";font-size:", _theme.fonts.sans.size.normal, ";font-weight:", _theme.fonts.sans.weight.bold, ";justify-content:center;outline:none;text-align:center;text-decoration:none;text-transform:uppercase;transition:all 0.3s ease;vertical-align:top;white-space:nowrap;width:auto;letter-spacing:0.03em;& + button{margin-left:5px;}", function (props) {
  return buttonVariants[props.size];
}, ";", function (props) {
  return buttonVariants[props.variant];
}, ";&:disabled,&:disabled:hover,&:disabled:focus{transition:none;cursor:not-allowed;background:", _theme.colors.grey.secondaryDark, " !important;border-color:", _theme.colors.grey.secondaryDark, ";color:", _theme.colors.grey.secondaryLight, ";text-decoration:none;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
exports.Button = Button;
Button.defaultProps = {
  children: null,
  variant: 'transparent',
  size: 'medium',
  disabled: false
};
Button.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  variant: _propTypes.default.oneOf(['primary', 'secondary', 'transparent', 'disabled']),
  size: _propTypes.default.oneOf(['small', 'medium']),
  disabled: _propTypes.default.bool
};

var ButtonWithProgress = function ButtonWithProgress(props) {
  var children = props.children,
      disabled = props.disabled;
  return _react.default.createElement(Button, _extends({}, props, {
    disabled: disabled
  }), disabled ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_icons.Icon, {
    color: _theme.colors.white,
    type: "spinner",
    spin: "clockwise",
    withText: true
  }), children) : _react.default.createElement(_react.default.Fragment, null, children));
};

exports.ButtonWithProgress = ButtonWithProgress;
ButtonWithProgress.defaultProps = {
  disabled: false,
  onClick: function onClick() {
    return undefined;
  },
  children: null
};
ButtonWithProgress.propTypes = {
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element])
};

var SubmitButton = function SubmitButton(props) {
  return _react.default.createElement(Button, _extends({}, props, {
    type: "submit",
    onClick: function onClick() {},
    variant: "primary"
  }), "Submit");
};

exports.SubmitButton = SubmitButton;
var LinkButton = (
/*#__PURE__*/
0, _styledBase.default)(_base.A, {
  target: "eimavvp1",
  label: "LinkButton"
})("line-height:1;display:inline-flex;text-transform:uppercase;", function (props) {
  return buttonVariants[props.size];
}, ";& + button{margin-left:5px;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
exports.LinkButton = LinkButton;
LinkButton.defaultProps = {
  size: 'medium'
};
LinkButton.propTypes = {
  href: _propTypes.default.string.isRequired,
  size: _propTypes.default.string
};

var CancelLinkButton = function CancelLinkButton(props) {
  return _react.default.createElement(LinkButton, props, "Cancel");
};

exports.CancelLinkButton = CancelLinkButton;
CancelLinkButton.defaultProps = {};
CancelLinkButton.propTypes = {
  href: _propTypes.default.string.isRequired
};